function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Grupo_2220",
  "data-name": "Grupo 2220",
  transform: "translate(-270.647 -992.75)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Grupo_2144",
  "data-name": "Grupo 2144",
  transform: "translate(270.684 991.921)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Grupo_531",
  "data-name": "Grupo 531",
  transform: "translate(18.383 7.032)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Grupo_529",
  "data-name": "Grupo 529"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Ret\\xE2ngulo_1411",
  "data-name": "Ret\\xE2ngulo 1411",
  width: 1.391,
  height: 8.145,
  fill: "#fff",
  stroke: "#f5f5f5",
  strokeWidth: 0.5
})), /*#__PURE__*/React.createElement("g", {
  id: "Grupo_530",
  "data-name": "Grupo 530",
  transform: "translate(0.039 7.148)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Ret\\xE2ngulo_1412",
  "data-name": "Ret\\xE2ngulo 1412",
  width: 1.391,
  height: 8.145,
  transform: "translate(0 0.983) rotate(-45)",
  fill: "#fff",
  stroke: "#f5f5f5",
  strokeWidth: 0.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "Grupo_566",
  "data-name": "Grupo 566",
  transform: "translate(0.316 1.079)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Grupo_565",
  "data-name": "Grupo 565",
  transform: "translate(0 8.058)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Grupo_563",
  "data-name": "Grupo 563"
}, /*#__PURE__*/React.createElement("g", {
  id: "Grupo_562",
  "data-name": "Grupo 562"
}, /*#__PURE__*/React.createElement("path", {
  id: "Caminho_868",
  "data-name": "Caminho 868",
  d: "M23.869,28.237l-6.553-6,.941-1.027,5.536,5.073,5.072-5.4,1.007.953Z",
  transform: "translate(-17.316 -20.882)",
  fill: "#fff",
  stroke: "#f5f5f5",
  strokeWidth: 0.5
})))), /*#__PURE__*/React.createElement("g", {
  id: "Grupo_528",
  "data-name": "Grupo 528",
  transform: "translate(5.347 0)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Caminho_1140",
  "data-name": "Caminho 1140",
  d: "M33.919,16.079A13.418,13.418,0,0,0,20.5,29.4h1.389A12.027,12.027,0,0,1,33.919,17.47v0A12.043,12.043,0,0,1,45.948,29.5v0a12.02,12.02,0,0,1-20.333,8.69l-.983.983a13.417,13.417,0,1,0,9.287-23.1Z",
  transform: "translate(-20.503 -16.079)",
  fill: "#fff",
  stroke: "#f5f5f5",
  strokeWidth: 0.5
})))));

function SvgHistory(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.787,
    height: 27.342,
    viewBox: "0 0 32.787 27.342",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistory);
export default __webpack_public_path__ + "static/media/history.0e3850b7.svg";
export { ForwardRef as ReactComponent };